function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Center, Flex, HStack, Text, Link as ChakraLink } from '@chakra-ui/react';
import { Link } from 'react-router';
import { ExternalUrls, WebRoutes } from '@/utils/constants';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export default function Footer(props) {
    return /*#__PURE__*/ _jsx(Center, _object_spread_props(_object_spread({
        borderTopWidth: 1,
        borderTopColor: "borderSecondary",
        backgroundColor: "backgroundSecondary"
    }, props), {
        children: /*#__PURE__*/ _jsxs(Flex, {
            p: 4,
            flex: 1,
            maxWidth: "container.xl",
            justifyContent: "space-between",
            color: "textSecondary",
            textAlign: {
                base: 'center',
                xl: 'left'
            },
            alignItems: "center",
            flexDir: {
                base: 'column',
                xl: 'row'
            },
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    fontSize: "sm",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "Gd/x0m",
                        defaultMessage: "Copyright \xa9 {year} NightDev, LLC. All Rights Reserved.",
                        values: {
                            year: new Date().getFullYear()
                        }
                    })
                }),
                /*#__PURE__*/ _jsxs(HStack, {
                    display: {
                        base: 'none',
                        sm: 'flex'
                    },
                    fontSize: "sm",
                    color: "textSecondary",
                    children: [
                        /*#__PURE__*/ _jsx(ChakraLink, {
                            as: Link,
                            to: WebRoutes.TERMS,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "32rBNK",
                                defaultMessage: "Terms of Service"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            children: "•"
                        }),
                        /*#__PURE__*/ _jsx(ChakraLink, {
                            as: Link,
                            to: WebRoutes.PRIVACY,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "vx0nkZ",
                                defaultMessage: "Privacy Policy"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            children: "•"
                        }),
                        /*#__PURE__*/ _jsx(ChakraLink, {
                            href: ExternalUrls.API_DOCS,
                            isExternal: true,
                            target: "_blank",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "yKOyCk",
                                defaultMessage: "API Documentation"
                            })
                        })
                    ]
                })
            ]
        })
    }));
}
